export function getInitials(name: string): string {
  if (!name) return '?';
  const cleaned = name.trim().replace(/\s+/g, ' ');
  if (!cleaned) return '?';
  const parts = cleaned.split(' ').filter(Boolean);
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  const first = parts[0]!;
  const last = parts[parts.length - 1]!;
  return (first[0]! + last[0]!).toUpperCase();
}
